import { StyledSubject } from './style';

export const QuoteSubject = ({ subject }) => <StyledSubject>{subject}</StyledSubject>;
